import { Divider } from '../Divider';

const SidepanelDivider = () => (
  <Divider rcx-sidepanel--divider mbs={-2} mbe={0} />
);

export default SidepanelDivider;
